module.exports = __webpack_public_path__ + "static/circle_logo-0869dfdaa263ffa798c809f80d17f3a2.svg";